module.exports = __webpack_public_path__ + "static/media/rank_icon.6e557e0a.svg";